import { base64urlToBuffer } from './webauthn';

/**
 * The address a session belongs to, read from its access token's `sub`. Used to
 * show the right account while /auth/me loads when nobody typed an email — a
 * sign-in through another account never does. Empty when it cannot be read; the
 * token is only read for display, never trusted for a decision.
 */
export function emailFromAccessToken(accessToken: string): string {
  try {
    const payload: unknown = JSON.parse(
      new TextDecoder().decode(base64urlToBuffer(accessToken.split('.')[1])),
    );
    const sub = (payload as { sub?: unknown } | null)?.sub;
    return typeof sub === 'string' ? sub : '';
  } catch {
    return '';
  }
}

/**
 * How long an access token lives, in milliseconds (`exp` minus `iat`), a length of time that
 * does not depend on whose clock is right. Null when either claim cannot be read.
 */
export function accessTokenLifetimeMs(accessToken: string): number | null {
  try {
    const payload: unknown = JSON.parse(
      new TextDecoder().decode(base64urlToBuffer(accessToken.split('.')[1])),
    );
    const { exp, iat } = (payload ?? {}) as { exp?: unknown; iat?: unknown };
    if (typeof exp !== 'number' || typeof iat !== 'number') return null;
    const lifetime = (exp - iat) * 1000;
    return Number.isFinite(lifetime) && lifetime > 0 ? lifetime : null;
  } catch {
    return null;
  }
}
